import React, { FC, ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { WorkExperienceData } from '../WorkExperience';
import { CompanyLogo } from '../../shared/CompanyLogo';
import { TimelineItem } from '../Timeline';
import { ExperienceDetails } from '../Experience';

export interface WorkExperienceItemProps {
    companyExperiences: WorkExperienceData[];
    statusBadge?: ReactNode;
}

export const WorkExperienceItem: FC<WorkExperienceItemProps> = ({ companyExperiences, statusBadge }) => {
    const firstExperience = companyExperiences[0];
    const { logo, name: companyName = '' } = firstExperience.company || {};
    const isMultipleExperiences = companyExperiences.length > 1;

    const experienceItemBody = (
        <Stack gap="3" paddingBottom={isMultipleExperiences ? '3' : undefined}>
            <CompanyLogo logoUrl={logo || undefined} name={companyName} size={40} />
            <Stack direction="column" minWidth={0} flexGrow={1}>
                <ExperienceDetails
                    experience={firstExperience}
                    isMultipleExperiences={isMultipleExperiences}
                    companyExperiences={companyExperiences}
                    statusBadge={statusBadge}
                />
            </Stack>
        </Stack>
    );

    return (
        <Stack direction="column" gap={isMultipleExperiences ? '0' : '3'}>
            {experienceItemBody}

            {isMultipleExperiences && (
                <Stack gap="0" direction="column">
                    {companyExperiences.map((experience, index) => (
                        <TimelineItem key={experience.id} isLast={index === companyExperiences.length - 1}>
                            <ExperienceDetails
                                experience={experience}
                                inTimeline={true}
                                isMultipleExperiences={true}
                                companyExperiences={companyExperiences}
                            />
                        </TimelineItem>
                    ))}
                </Stack>
            )}
        </Stack>
    );
};
